import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import AboutMission from './components/AboutMission';
import AboutValues from './components/AboutValues';

const SobrePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <AboutHero />
        <AboutMission />
        <AboutValues />
      </main>
      <Footer />
    </div>
  );
};

export default SobrePage;